import { NavLink, useParams } from "react-router-dom"
import { useContext } from "react"
import { useTranslation } from "react-i18next"
import { UserContext } from "../../hooks/UserContext"
import { userHasPermission } from "../../navigation/NavegationRoutes"
import {
    WORKFORCE_RATES,
    WORKFORCE_COSTS,
    WORKFORCE_SHIFTS,
    WORKFORCE_OPERATORS,
    WORKFORCE_ATTENDANCE,
    WORKFORCE_SCHEDULE,
} from "../../navigation/constants"

const buildTabs = (t, user) => {
    const tabs = []
    if (userHasPermission(user, 'index_operator_costs')) {
        tabs.push({ key: 'costs', href: WORKFORCE_COSTS, label: t('workforce.tabs.costs') })
    }
    if (userHasPermission(user, 'manage_operator_rates')) {
        tabs.push({ key: 'rates', href: WORKFORCE_RATES, label: t('workforce.tabs.rates') })
    }
    if (userHasPermission(user, 'manage_workforce_shifts')) {
        tabs.push({ key: 'shifts', href: WORKFORCE_SHIFTS, label: t('workforce.tabs.shifts') })
    }
    if (userHasPermission(user, 'manage_workforce_shifts')) {
        tabs.push({ key: 'schedule', href: WORKFORCE_SCHEDULE, label: t('workforce.tabs.schedule') })
    }
    if (userHasPermission(user, 'manage_warehouse_operators')) {
        tabs.push({ key: 'operators', href: WORKFORCE_OPERATORS, label: t('workforce.tabs.operators') })
    }
    if (userHasPermission(user, 'mark_attendance')) {
        tabs.push({ key: 'attendance', href: WORKFORCE_ATTENDANCE, label: t('workforce.tabs.attendance') })
    }
    return tabs
}

export const WorkforceTabs = () => {
    const { user } = useContext(UserContext)
    const { warehouse_id } = useParams()
    const { t } = useTranslation()

    const tabs = buildTabs(t, user)

    if (tabs.length === 0) return null

    return (
        <div className="border-b border-gray-200 bg-white">
            <nav className="-mb-px flex space-x-6 px-4" aria-label="Workforce tabs">
                {tabs.map((tab) => (
                    <NavLink
                        key={tab.key}
                        to={tab.href.replace(':warehouse_id', warehouse_id)}
                        className="whitespace-nowrap py-3 px-1 border-b-2 border-transparent text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300"
                        activeClassName="border-yellow-500 text-yellow-600"
                    >
                        {tab.label}
                    </NavLink>
                ))}
            </nav>
        </div>
    )
}

export const getDefaultWorkforceLanding = (user, warehouse_id) => {
    if (userHasPermission(user, 'index_operator_costs')) return WORKFORCE_COSTS.replace(':warehouse_id', warehouse_id)
    if (userHasPermission(user, 'manage_operator_rates')) return WORKFORCE_RATES.replace(':warehouse_id', warehouse_id)
    if (userHasPermission(user, 'manage_workforce_shifts')) return WORKFORCE_SHIFTS.replace(':warehouse_id', warehouse_id)
    if (userHasPermission(user, 'manage_warehouse_operators')) return WORKFORCE_OPERATORS.replace(':warehouse_id', warehouse_id)
    if (userHasPermission(user, 'mark_attendance')) return WORKFORCE_ATTENDANCE.replace(':warehouse_id', warehouse_id)
    return null
}
